import styled from 'styled-components';

export const MaxCharLabel = styled.div`
  font-weight: ${props => (props.maxLengthExceeded ? '700' : 'normal')};
  font-size: ${props => props.theme.fontSizeSmall};
  color: ${props => (props.maxLengthExceeded ? props.theme.invalidColor : props.theme.labelColor)};
`;
